# Bewegung & Spiel: Aktivität für jedes Tier

Bewegung hält Gelenke gesund, unterstützt das Gewicht und reduziert Stress. Konstanz ist wichtiger als Intensität – bauen Sie Routinen auf, die Spaß machen.

<ArticleImage
  src="https://images.unsplash.com/photo-1650633907713-e0a619c1a69a?q=80&w=1633&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
  alt="Person geht spazieren"
  caption="Tägliche Spaziergänge sind eine einfache, wirksame Basis."
/>

---

<Section emoji="🚶" title="Bewegung im Alltag">

<Tip label="Schnüffelrunden" text="Zeit zum Schnüffeln ist mentale Auslastung und Bewegung zugleich." />
<Tip label="Indoor‑Alternativen" text="Apportieren im Flur, Zerrspiele oder kurze Trainingseinheiten." />
<Tip label="Regelmäßigkeit" text="Feste Zeiten helfen, sich an die Routine zu gewöhnen." />

</Section>

<ArticleImage
  src="https://images.unsplash.com/photo-1629898452932-07074d3f9944?q=80&w=1074&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
  alt="Trainingszubehör"
  caption="Kraft und Balance halten Tiere agil und sicher."
/>

<Section emoji="🧠" title="Spiel für den Kopf">

<Tip label="Futterpuzzles" text="Beschäftigen und beugen Langeweile vor." />
<Tip label="Kurztraining" text="Fünf Minuten Sitz, Bleib oder Target reichen oft." />
<Tip label="Spielzeug rotieren" text="Wechsel schafft Abwechslung ohne Neukauf." />

</Section>

<ArticleImage
  src="/images/guide/exercise-goat.jpg"
  alt="Schwimmbad"
  caption="Gelenkschonende Aktivitäten sind ideal für Senioren."
/>

<Section emoji="🧬" title="Alter, Rasse & Gesundheit">

<Tip label="Welpen & Kitten" text="Kurz und häufig statt lang und intensiv." />
<Tip label="Senioren" text="Sanfte Spaziergänge und weiche Untergründe schonen Gelenke." />
<Tip label="Kurznasen" text="Hitze und starke Anstrengung vermeiden, Atmung beobachten." />

</Section>

<Section emoji="🌦️" title="Sicherheit & Wetter">

<Tip label="Wasser" text="Wasser mitnehmen und Pausen einlegen." />
<Tip label="Heißer Boden" text="Ist es zu heiß für die Hand, ist es zu heiß für Pfoten." />
<Tip label="Erholung" text="Ruhetage gehören dazu." />

</Section>

<Disclaimer title="⚠️ Hinweis">
Dieser Leitfaden ersetzt keine tierärztliche Beratung. Bei Husten, Lahmheit oder starker Müdigkeit den Tierarzt kontaktieren.
</Disclaimer>
